(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementType', MusicalArrangementType);

    MusicalArrangementType.$inject = ['$resource'];

    function MusicalArrangementType ($resource) {
        var resourceUrl =  'api/musical-arrangement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
